"use client";

import { RoomAudioRenderer } from "@livekit/components-react";
import { useEffect, useId } from "react";

type MountedRoomAudioRenderer = {
  activeSession: boolean;
  mountedAt: number;
  roomName: string | null;
  surface: string;
};

type TrackedRoomAudioRendererProps = {
  activeSession?: boolean;
  roomName?: string | null;
  surface: string;
};

const mountedAudioRenderers = new Map<string, MountedRoomAudioRenderer>();

export function getMountedRoomAudioRendererDiagnostics() {
  const renderers = Array.from(mountedAudioRenderers.values());
  const activeRenderers = renderers.filter((renderer) => renderer.activeSession);

  return {
    mountedAudioRendererCount: renderers.length,
    activeMountedAudioRendererCount: activeRenderers.length,
    mountedAudioRendererSurfaces: renderers.map((renderer) => ({
      activeSession: renderer.activeSession,
      mountedForMs: Math.max(0, Date.now() - renderer.mountedAt),
      roomName: renderer.roomName,
      surface: renderer.surface,
    })),
  };
}

export function TrackedRoomAudioRenderer({
  activeSession = true,
  roomName = null,
  surface,
}: TrackedRoomAudioRendererProps) {
  const id = useId();

  useEffect(() => {
    mountedAudioRenderers.set(id, {
      activeSession,
      mountedAt: Date.now(),
      roomName,
      surface,
    });

    return () => {
      mountedAudioRenderers.delete(id);
    };
  }, [activeSession, id, roomName, surface]);

  return <RoomAudioRenderer />;
}
